import { AddressInputValue } from '@modusign/react-signing/types';

/**
 *
 * @param options onlyBasicAddress:true면 [우편번호] 시/도 시/군/구 주소 형식으로 반환 onlyBasicAddress:false면 [우편번호] 시/도 시/군/구 주소 상세주소 형식으로 반환
 * @returns string으로 변환된 주소
 */
export default function formatAddressToString(
  address: AddressInputValue | undefined,
  options?: {
    formatMode?: 'full' | 'basic';
  }
) {
  if (!address || !isAddressFieldInputFilled(address)) {
    return '';
  }

  const { formatMode } = options ?? { formatMode: 'full' };
  switch (address.country) {
    case 'KR': {
      const city = address.city ? ` ${address.city}` : '';
      return formatMode === 'basic'
        ? `[${address.zip}] ${address.province}${city} ${address.address1}`
        : `[${address.zip}] ${address.province}${city} ${address.address1}${
            address.address2 ? ` ${address.address2}` : ''
          }`;
    }
    default: {
      return '';
    }
  }
}

function isAddressFieldInputFilled(inputValue?: AddressInputValue): boolean {
  if (!inputValue) {
    return false;
  }

  /**
   * 세종시는 시/군/구가 없기 때문에 세종특별시에서는 city를 검사하지 않습니다.
   * 세종특별자치시 설치 등에 관한 특별법 (제6조 3항)
   * FYI - https://www.law.go.kr/%EB%B2%95%EB%A0%B9/%EC%84%B8%EC%A2%85%ED%8A%B9%EB%B3%84%EC%9E%90%EC%B9%98%EC%8B%9C%EC%84%A4%EC%B9%98%EB%93%B1%EC%97%90%EA%B4%80%ED%95%9C%ED%8A%B9%EB%B3%84%EB%B2%95/(20230710,19430,20230609)/%EC%A0%9C6%EC%A1%B0
   * */
  const isSejong = inputValue.province?.startsWith('세종');
  return (
    inputValue.address1 !== '' &&
    inputValue.province !== '' &&
    inputValue.zip !== '' &&
    (isSejong || !!inputValue.city)
  );
}
